import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export interface DeleteConfirmDialogData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-delete-confirm-dialog',
  template: `
    <div class="delete-dialog">
      <div class="delete-dialog-header">
        <h4>{{ data.title || 'XÁC NHẬN XÓA' }}</h4>
        <button type="button" class="btn-close" (click)="onClose()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      
      <div class="delete-dialog-body">
        <p>{{ data.message }}</p>
        
        <form [formGroup]="passwordForm">
          <div class="form-group">
            <label>Vui lòng nhập mật khẩu tài khoản để xác nhận <span class="text-danger">*</span></label>
            <input 
              type="password" 
              class="form-control mt-2" 
              formControlName="password"
              placeholder="Nhập mật khẩu"
            />
            <div *ngIf="submitted && passwordForm.controls['password'].errors" class="invalid-feedback d-block">
              <div *ngIf="passwordForm.controls['password'].errors['required']">Vui lòng nhập mật khẩu</div>
            </div>
          </div>
        </form>
      </div>
      
      <div class="delete-dialog-footer">
        <button type="button" class="btn btn-secondary" (click)="onClose()">
          <i class="ti ti-x me-1"></i> Đóng
        </button>
        <button type="button" class="btn btn-danger" (click)="onConfirm()">
          <i class="ti ti-check me-1"></i> Đồng ý
        </button>
      </div>
    </div>
  `,
  styles: [`
    .delete-dialog {
      position: relative;
    }
    .delete-dialog-header {
      background-color: #E53935;
      color: white;
      padding: 15px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .delete-dialog-header h4 {
      margin: 0;
      font-size: 18px;
      font-weight: 500;
    }
    .btn-close {
      background: none;
      border: none;
      color: white;
      font-size: 20px;
      cursor: pointer;
    }
    .delete-dialog-body {
      padding: 20px;
    }
    .delete-dialog-body p {
      margin-bottom: 20px;
    }
    .delete-dialog-footer {
      padding: 15px 20px;
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      border-top: 1px solid #e9ecef;
    }
    .btn-secondary {
      background-color: #f0f2f5;
      border: 1px solid #dee2e6;
      color: #333;
    }
    .btn-danger {
      background-color: #E53935;
      border: none;
      color: white;
    }
    .text-danger {
      color: #dc3545;
    }
    .invalid-feedback {
      color: #dc3545;
      font-size: 12px;
      margin-top: 4px;
    }
  `]
})
export class DeleteConfirmDialogComponent implements OnInit {
  passwordForm: FormGroup;
  submitted = false;

  constructor(
    public dialogRef: MatDialogRef<DeleteConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteConfirmDialogData,
    private fb: FormBuilder
  ) {
    this.passwordForm = this.fb.group({
      password: ['', Validators.required]
    });
  }

  ngOnInit(): void {
  }

  onClose(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    this.submitted = true;
    
    if (this.passwordForm.invalid) {
      return;
    }
    
    this.dialogRef.close({
      password: this.passwordForm.controls['password'].value
    });
  }
} 